module.exports = __webpack_public_path__ + "static/media/amp.b57ee201.jpg";